<template>
  <el-row>
    <el-col>
      {{id}}
    </el-col>
    <el-col>
      <span v-on:click="$emit('toBeGoodOrNot')">
      {{title}}
      </span>
    </el-col>
      <el-col>
        <el-button v-show="good" type="success" circle><icon name="appreciate (y)" :w="20" :h="20" ></icon></el-button>
      </el-col>
  </el-row>
</template>

<script>
export default {
  name: 'item',
  props: ['id', 'title', 'good']
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Item.vue